export const EDIT_MODE_SMALL_LAPTOP = '(min-width: 1169px)'
export const EDIT_MODE_LAPTOP_BREAKPOINT = '(min-width: 1200px)'
export const EDIT_MODE_TABLET_BREAKPOINT = '(min-width: 995px)'
export const MIDDLE_TABLET_LAPTOP_BREAKPOINT = '(min-width: 941px)'
